import {
  GcfCommonComponentConfigInterface,
  GcfCommonComponentConfigSchema,
} from '../FormSelector.interface';
import { ListingWithOptionalVisualsColumnStyle } from '../listingWithOptionalVisuals/ListingWithOptionalVisuals.interface';

type Omit<T, K extends keyof GcfCommonComponentConfigInterface> = Pick<
  T,
  Exclude<keyof T, K>
>;

export interface ListingVisualsGalleryConfigInterface
  extends Omit<GcfCommonComponentConfigInterface, 'cycling'> {
  columnStyle?: ListingWithOptionalVisualsColumnStyle;
  lineupColumns?: number;
  listingHeight?: number;
  showAllVisuals?: boolean;
}

const {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  properties: { cycling, ...GcfCommonProperties },
} = GcfCommonComponentConfigSchema;

const gridSystemSchema = {
  type: 'number',
  minimum: 1,
  maximum: 12,
};

export const ListingVisualsGalleryConfigSchema = {
  title: 'Listing with Optional Visuals JSON Config',
  description: 'JSON Configuration Options for GCF Listing Visuals Gallery',
  type: 'object',
  properties: {
    ...GcfCommonProperties,
    subheader: {
      ...GcfCommonComponentConfigSchema.properties.subheader,
    },
    columnStyle: {
      type: 'string',
      enum: [
        ListingWithOptionalVisualsColumnStyle.category,
        ListingWithOptionalVisualsColumnStyle.continuous,
      ],
    },
    lineupColumns: {
      type: 'number',
    },
    listingHeight: gridSystemSchema,
    showAllVisuals: {
      type: 'boolean',
    },
  },
  required: [...GcfCommonComponentConfigSchema.required],
};
